(function () {

    var scheduleDataServiceV2;
    var scheduleCostsServiceV2;
    var teamScheduleService;
    var UserServices;
    var _filter;
    var _TSUsersService;
    var _nunjucks;
    var _scheduleDateUtilsService;

    function FairSchedulingService () {
        var self = this;

        var currency;
        var cache = {};
        var usersPublishedShiftsMap = {};
        var _coveredEmployeesRules = {};
        var _usersCostMap = {};
        var PENALTY_PAYMENT_INTERVALS = {
            ONE_HOUR: 'ONE_HOUR',
            TWO_HOURS: 'TWO_HOURS',
            FOUR_HOURS: 'FOUR_HOURS',
            AFFECTED_HOURS: 'AFFECTED_HOURS',
            FOUR_HRS_OR_AFFECTED_HRS_WHICHEVER_LESS: 'FOUR_HRS_OR_AFFECTED_HRS_WHICHEVER_LESS'
        };
        var REFERENCE_TYPES = {
            SHIFT_DAY: 'SHIFT_DAY',
            FIRST_DAY_OF_WEEK: 'FIRST_DAY_OF_WEEK',
        };

        self.PENALTY_STATUS = {
            IGNORED: 'IGNORED',
            SYSTEM_IGNORED: 'SYSTEM_IGNORED',
        };

        self.PENALTY_SYSTEM_IGNORE_ELIGIBILITY_TYPE = {
            NEW_HIRE: 'NEW_HIRE',
            VOLUNTARY_STANDBY_LIST: 'VOLUNTARY_STANDBY_LIST',
            FWW_24_HOUR_WINDOW: 'FWW_24_HOUR_WINDOW',
            UNASSIGNED_SHIFT_PICKUP: 'UNASSIGNED_SHIFT_PICKUP',
            NON_COVERED: 'NON_COVERED',
            EMPLOYEE_REQUESTED: 'EMPLOYEE_REQUESTED',
            MASS_COMMUNICATION: 'MASS_COMMUNICATION',
            INAPPLICABLE_SCHEDULED_RIGHT_TO_REST: 'INAPPLICABLE_SCHEDULED_RIGHT_TO_REST',
        };

        self.parseFlatScheduleData = function (scheduleData) {
            var flatData = [];

            for (var i in scheduleData.roles) {
                var role = scheduleData.roles[i];

                for (var j in role.role_days) {
                    var roleDay = role.role_days[j];

                    for (var k in roleDay.assignees) {
                        var assignee = roleDay.assignees[k];
                        var userId = assignee.user_id;

                        for (var l in assignee.assignee_shifts) {
                            var shift = assignee.assignee_shifts[l];

                            shift['role_id'] = role.id;
                            shift['roleday_id'] = roleDay.id;
                            shift['assignee_id'] = assignee.id;
                            shift['user_id'] = userId;
                            shift['day'] = roleDay.date;
                            shift['brand_id'] = scheduleData['brand_id'];
                            shift['position'] = role.position;

                            flatData.push(shift);
                        }
                    }
                }
            }

            var sortedFlatData = _.sortBy(flatData, function (shift) {
                if (shift) {
                    return _scheduleDateUtilsService.moment(shift.start_time).valueOf() + "_" + _scheduleDateUtilsService.moment(shift.end_time).valueOf();
                }
            });

            return sortedFlatData;
        };

        self.loadSchedulePublishTree = function (brandId, startDayOfWeek) {
            var defer = $q.defer();

            var dateStringified = JSON.stringify(startDayOfWeek);
            var cacheKey = dateStringified + '_' + 'PUBLISHED';
            cache[brandId] = cache[brandId] || {};
            cache[brandId]['schedules'] = cache[brandId]['schedules'] || {};

            if (cache[brandId]['schedules'][cacheKey]) {
                defer.resolve(angular.copy(cache[brandId]['schedules'][cacheKey]));
            }
            else {
                TeamScheduleV2API
                    .getBrandSchedule(brandId, startDayOfWeek, null, 'PUBLISHED')
                    .then(function (scheduleData) {
                        cache[brandId]['schedules'][cacheKey] = scheduleData[0] || {};
                        defer.resolve(angular.copy(cache[brandId]['schedules'][cacheKey]));
                    })
                    .catch(function (err) {
                        console.error(err);
                        defer.reject(err);
                    });
            }

            return defer.promise;
        };

        var getActiveCoveredEmployeesRules = function (coveredEmployeesRulesList) {
            var rulesMap = {};

            if (coveredEmployeesRulesList.length) {
                coveredEmployeesRulesList.sort(function (item1, item2) {
                    return new Date(item1.start_date).getTime() > new Date(item2.start_date).getTime() ? -1 : 1;
                });

                var salariedEmployeesRule = _.findWhere(coveredEmployeesRulesList, {payment_type: 'SALARIED'});
                var shiftBasedEmployeesRule = _.findWhere(coveredEmployeesRulesList, {payment_type: 'WEIGHTED_SHIFT'});
                var hourlyEmployeesRule = _.findWhere(coveredEmployeesRulesList, {payment_type: 'HOURLY'});

                if (salariedEmployeesRule && salariedEmployeesRule['rate_threshold']) {
                    rulesMap['SALARIED'] = salariedEmployeesRule;
                }

                if (shiftBasedEmployeesRule && shiftBasedEmployeesRule['rate_threshold']) {
                    rulesMap['WEIGHTED_SHIFT'] = shiftBasedEmployeesRule;
                }

                if (hourlyEmployeesRule && hourlyEmployeesRule['rate_threshold']) {
                    rulesMap['HOURLY'] = hourlyEmployeesRule;
                }
            }

            return rulesMap;
        };

        var getActiveTippedEmployeesRule = function (tippedRulesList) {
            var activeRule;

            if (tippedRulesList.length) {
                var latestDate = tippedRulesList[0].start_date;

                for (var i in tippedRulesList) {
                    if ((tippedRulesList[i].start_date === latestDate) && tippedRulesList[i].status === 'ACTIVE') {
                        activeRule = tippedRulesList[i];
                        break;
                    }
                }
            }

            return activeRule;
        };

        var check24WindowRuleEnabled = function (fwwPublishGracePeriodSettings, thresholds) {
            var activeRule;

            if (fwwPublishGracePeriodSettings.length) {
                var latestDate = fwwPublishGracePeriodSettings[0].start_date;

                for (var i in fwwPublishGracePeriodSettings) {
                    if ((fwwPublishGracePeriodSettings[i].start_date === latestDate) && fwwPublishGracePeriodSettings[i].status === 'ENABLED') {
                        activeRule = fwwPublishGracePeriodSettings[i];
                        break;
                    }
                }
            }

            return activeRule && thresholds.indexOf(14) > -1;
        };

        var preparePenaltySettings = function (penaltySettings) {
            var penaltyRulesMap = {};

            penaltySettings.sort(function (item1, item2) {
                return new Date(item1.start_date).getTime() > new Date(item2.start_date).getTime() ? -1 : 1;
            });

            var latestDate = penaltySettings[0] && penaltySettings[0]['start_date'];
            var latestRules = _.filter(penaltySettings, function (penalty) {
                return (penalty.start_date === latestDate);
            });

            for (var i in latestRules) {
                var penaltyRule = latestRules[i];
                var operation = (
                    penaltyRule.eligibility_settings && penaltyRule.eligibility_settings[0] && penaltyRule.eligibility_settings[0].operation
                ) || 'DEFAULT_RULE';
                var penaltyRuleThreshold = (
                    penaltyRule.shift_penalty_change_threshold_value === 24 &&
                    penaltyRule.shift_penalty_change_threshold_type === 'HOUR' ? 0 : penaltyRule.shift_penalty_change_threshold_value
                );

                penaltyRulesMap[penaltyRuleThreshold] = penaltyRulesMap[penaltyRuleThreshold] || {
                    threshold: penaltyRuleThreshold,
                    rules: {}
                };

                if (
                    penaltyRulesMap[penaltyRuleThreshold]['rules'][penaltyRule.shift_penalty_change_type] &&
                    penaltyRulesMap[penaltyRuleThreshold]['rules'][penaltyRule.shift_penalty_change_type][operation]
                ) {
                    continue;
                }

                if (penaltyRule.status === 'ACTIVE') {
                    penaltyRulesMap[penaltyRuleThreshold]['rules'][penaltyRule.shift_penalty_change_type] = penaltyRulesMap[penaltyRuleThreshold]['rules'][penaltyRule.shift_penalty_change_type] || {};
                    penaltyRulesMap[penaltyRuleThreshold]['rules'][penaltyRule.shift_penalty_change_type][operation] = penaltyRule;
                }
            }

            return penaltyRulesMap;
        };

        var getScheduleThresholds = function (penaltyRulesMap) {
            var scheduleThresholds = [];

            for (var i in penaltyRulesMap) {
                scheduleThresholds.push(penaltyRulesMap[i].threshold);
            }

            scheduleThresholds = _.uniq(scheduleThresholds);

            scheduleThresholds.sort(function (threshold1, threshold2) {
                return threshold1 < threshold2 ? -1 : 1;
            });

            return scheduleThresholds;
        };

        var calculateShiftThreshold = function (nowInBrandTimezone, todayDate, startDayOfWeek, shiftStartTime, referenceType) {
            var penaltyReferenceTime = referenceType === REFERENCE_TYPES.FIRST_DAY_OF_WEEK ? startDayOfWeek : shiftStartTime;
            var shiftThresholdInSeconds = _scheduleDateUtilsService.moment(penaltyReferenceTime).diff(nowInBrandTimezone, 'seconds');
            var shiftThreshold;

            shiftThreshold = shiftThresholdInSeconds / 3600;

            if (shiftThreshold > 24) {
                shiftThreshold = _scheduleDateUtilsService.moment(penaltyReferenceTime).diff(todayDate, 'seconds');
                shiftThreshold = shiftThreshold / (24.0 * 60.0 * 60.0);
            } else if (shiftThreshold <= 24) {
                shiftThreshold = 0;
            }

            return shiftThreshold;
        };

        var prepareShiftsInfo = function (shifts, todayDate, nowInBrandTimezone, startDayOfWeek, startDayOfNextWeek) {
            var shiftsList = [];

            for (var i in shifts) {
                var shift = shifts[i];
                var shiftDate = _scheduleDateUtilsService.moment(shift.start_time, 'MMM DD, YYYY HH:mm').format('MMM DD, YYYY');
                var weekStartDate = startDayOfWeek;

                if (_scheduleDateUtilsService.moment(shift.start_time).isSameOrAfter(startDayOfNextWeek)) {
                    weekStartDate = startDayOfNextWeek;
                }
                shift['shift_day_threshold'] = calculateShiftThreshold(nowInBrandTimezone, todayDate, weekStartDate, shift.start_time, REFERENCE_TYPES.SHIFT_DAY);
                shift['first_day_of_week_threshold'] = calculateShiftThreshold(nowInBrandTimezone, todayDate, weekStartDate, shift.start_time, REFERENCE_TYPES.FIRST_DAY_OF_WEEK);
                shift['shift_date'] = shiftDate;

                var start = _scheduleDateUtilsService.moment(shift.start_time).valueOf();
                var end = _scheduleDateUtilsService.moment(shift.end_time).valueOf();
                var shiftPeriod = (end - start) / 1000;

                shift['length'] = shiftPeriod;

                shiftsList.push(shift);
            }

            return shiftsList;
        };

        let getEmployeeHourlyRate =  (userPayType, userCosts, penaltyItem, tippedRule, paymentType) => {
            let usedRate;

            if (userPayType === 'HOURLY') {
                var positionCost = penaltyItem['position'] && userCosts[penaltyItem['position']['code']];
                var shiftPosition = positionCost && positionCost[penaltyItem['day']];
                var hourCost = parseFloat((shiftPosition && shiftPosition.rate) || 0);
                var isTipped = shiftPosition && shiftPosition.is_tipped;
                var minimumWage = (
                    shiftPosition &&
                    shiftPosition.minimum_wage &&
                    shiftPosition.minimum_wage[0] &&
                    shiftPosition.minimum_wage[0].value / 100
                ) || 0;

                usedRate = hourCost;

                if (isTipped && tippedRule) {
                    if (
                        tippedRule['penalty_payment_type'] === "MINIMUM_WAGE" ||
                        (tippedRule['penalty_payment_type'] === "MAX_OF_MINIMUM_WAGE_OR_REGULAR_RATE" && (minimumWage > hourCost))
                    ) {
                        usedRate = minimumWage;
                    } else if (tippedRule['penalty_payment_type'] === "FIXED_PAYRATE" && (hourCost < minimumWage)) {
                        usedRate = tippedRule['penalty_payment_value'] / 100;
                    }
                } else if (paymentType === TeamScheduleAPI.PAYMENT_TYPES.BLENDED_RATE) {
                    usedRate = scheduleCostsServiceV2.calculateUserWeeklyBlendedRate(userCosts.user_id);
                }

                penaltyItem['allow_access'] = positionCost && positionCost['allow_access'];
            } else {
                var annualRate = userCosts['annual_rate'] && userCosts['annual_rate'][penaltyItem['day']];
                var annualSalary = (annualRate && annualRate['value'] || 0) / 100;
                var maxWeeklyHours = userCosts['max_weekly_hours'] && userCosts['max_weekly_hours'][penaltyItem['day']] && userCosts['max_weekly_hours'][penaltyItem['day']]['value'];
                penaltyItem['allow_access'] = annualRate && annualRate['allow_access'];

                if (maxWeeklyHours) {
                    usedRate = Utils.roundFloat(annualSalary / 52 / maxWeeklyHours);
                } else {
                    penaltyItem['show_undefined_penalty'] = true;
                }
            }

            return usedRate;
        };

        var getPenaltyTimeChangeAffectedValue = function (publishShift, unpublishShift) {
            var publishedShiftStartTime = _scheduleDateUtilsService.moment(publishShift.start_time).valueOf();
            var unpublishedShiftStartTime = _scheduleDateUtilsService.moment(unpublishShift.start_time).valueOf();

            return Math.abs((publishedShiftStartTime - unpublishedShiftStartTime) / 1000);
        };

        var applyPenalty = function (type, appliedRule, tippedRule, paytypePenaltyRule, userCosts, isEmployeeConsentFlowEnabled, publishShift, unpublishShift, moveChangeValue) {
            var publishShiftThreshold;
            var unPublishShiftThreshold;
            var penaltyItem = {
                fromShift: publishShift,
                toShift: unpublishShift,
                currency: currency
            };

            if (publishShift) {
                publishShiftThreshold = appliedRule.shift_penalty_reference_time_type === REFERENCE_TYPES.FIRST_DAY_OF_WEEK ? publishShift.first_day_of_week_threshold : publishShift.shift_day_threshold;
            }

            if (unpublishShift) {
                unPublishShiftThreshold = appliedRule.shift_penalty_reference_time_type === REFERENCE_TYPES.FIRST_DAY_OF_WEEK ? unpublishShift.first_day_of_week_threshold : unpublishShift.shift_day_threshold;
            }
            var userPayType = paytypePenaltyRule ? paytypePenaltyRule.payment_type : 'HOURLY';

            switch (type) {
                case 'MOVE':
                    penaltyItem['user_id'] = unpublishShift.user_id || publishShift.user_id;
                    penaltyItem['notice_period'] = Math.min(unPublishShiftThreshold, publishShiftThreshold);
                    penaltyItem['date'] = unpublishShift.shift_date || publishShift.shift_date;
                    penaltyItem['day'] = unpublishShift.day || publishShift.day;
                    penaltyItem['type'] = self.SHIFT_PENALTY_CHANGE_TYPES.DATE_TIME_CHANGE;
                    penaltyItem['change_value'] = moveChangeValue;
                    penaltyItem['position'] = unpublishShift.position;
                    penaltyItem['isRequiredEmployeeConsent'] = isEmployeeConsentFlowEnabled;
                    penaltyItem['employeeConsent'] = unpublishShift.employee_consent;
                    penaltyItem['isRequestedByAssignee'] = {
                        key: unpublishShift.is_requested_by_assignee ? 'YES' : 'NO',
                        value: unpublishShift.is_requested_by_assignee ? _filter('translate')('Yes') : _filter('translate')('No')
                    };
                    break;

                case 'ADD':
                    penaltyItem['user_id'] = unpublishShift.user_id;
                    penaltyItem['notice_period'] = unPublishShiftThreshold;
                    penaltyItem['date'] = unpublishShift.shift_date;
                    penaltyItem['day'] = unpublishShift.day;
                    penaltyItem['type'] = self.SHIFT_PENALTY_CHANGE_TYPES.LENGTH_INCREMENT;
                    penaltyItem['change_value'] = unpublishShift.length;
                    penaltyItem['position'] = unpublishShift.position;
                    penaltyItem['isRequiredEmployeeConsent'] = isEmployeeConsentFlowEnabled;
                    penaltyItem['employeeConsent'] = unpublishShift.employee_consent;
                    penaltyItem['isRequestedByAssignee'] = {
                        key: unpublishShift.is_requested_by_assignee ? 'YES' : 'NO',
                        value: unpublishShift.is_requested_by_assignee ? _filter('translate')('Yes') : _filter('translate')('No')
                    };
                    break;

                case 'SUBTRACT':
                    penaltyItem['user_id'] = publishShift.user_id;
                    penaltyItem['notice_period'] = publishShiftThreshold;
                    penaltyItem['date'] = publishShift.shift_date;
                    penaltyItem['day'] = publishShift.day;
                    penaltyItem['type'] = self.SHIFT_PENALTY_CHANGE_TYPES.LENGTH_DECREMENT;
                    penaltyItem['change_value'] = publishShift.length;
                    penaltyItem['position'] = publishShift.position;
                    penaltyItem['isRequiredEmployeeConsent'] = isEmployeeConsentFlowEnabled && publishShift.is_requested_by_assignee;
                    penaltyItem['isRequestedByAssignee'] = {
                        key: publishShift.is_requested_by_assignee ? 'YES' : 'NO',
                        value: publishShift.is_requested_by_assignee ? _filter('translate')('Yes') : _filter('translate')('No')
                    };
                    break;

                case 'CHANGE':
                    var shiftChange = unpublishShift.length - publishShift.length;

                    if (shiftChange > 0) {
                        penaltyItem['type'] = self.SHIFT_PENALTY_CHANGE_TYPES.LENGTH_INCREMENT;
                        penaltyItem['isRequiredEmployeeConsent'] = isEmployeeConsentFlowEnabled;
                        penaltyItem['isRequestedByAssignee'] = {
                            key: unpublishShift.is_requested_by_assignee ? 'YES' : 'NO',
                            value: unpublishShift.is_requested_by_assignee ? _filter('translate')('Yes') : _filter('translate')('No')
                        };
                    } else {
                        penaltyItem['type'] = self.SHIFT_PENALTY_CHANGE_TYPES.LENGTH_DECREMENT;
                        penaltyItem['isRequiredEmployeeConsent'] = isEmployeeConsentFlowEnabled && unpublishShift.is_requested_by_assignee;
                        penaltyItem['employeeConsent'] = unpublishShift.employee_consent;
                        penaltyItem['isRequestedByAssignee'] = {
                            key: unpublishShift.is_requested_by_assignee ? 'YES' : 'NO',
                            value: unpublishShift.is_requested_by_assignee ? _filter('translate')('Yes') : _filter('translate')('No')
                        };
                    }

                    penaltyItem['user_id'] = unpublishShift.user_id || publishShift.user_id;
                    penaltyItem['notice_period'] = Math.min(unPublishShiftThreshold, publishShiftThreshold);
                    penaltyItem['date'] = unpublishShift.shift_date || publishShift.shift_date;
                    penaltyItem['change_value'] = Math.abs(shiftChange);
                    penaltyItem['position'] = unpublishShift.position;
                    penaltyItem['day'] = unpublishShift.day || publishShift.day;
                    break;
            }

            var isNewHiredEmployee = self.isNewlyHiedWithNoPublishSchedule(penaltyItem['day'], penaltyItem['user_id']);

            if (isNewHiredEmployee) {
                return;
            }

            penaltyItem['change_value'] = penaltyItem['change_value'] && Utils.roundFloat(penaltyItem['change_value']);

            let usedRate = getEmployeeHourlyRate(userPayType, userCosts, penaltyItem, tippedRule, appliedRule[TeamScheduleAPI.RESPONSE_TAGS.PENALTY_PAYMENT_TYPE]);

            penaltyItem['penalty'] = getAppliedPenaltyValue(appliedRule, penaltyItem, usedRate);

            return penaltyItem;
        };

        var getAppliedPenaltyValue = function (appliedRule, penaltyItem, usedRate) {
            var penalty;

            if (penaltyItem.isRequiredEmployeeConsent && penaltyItem.isRequestedByAssignee && penaltyItem.isRequestedByAssignee.key === 'YES') {
                penalty = 0;
            } else {
                if (appliedRule['penalty_payment_type'] === 'FIXED') {
                    penalty = appliedRule['penalty_payment_value'] / 100;
                } else {
                    switch (appliedRule['penalty_payment_interval']) {
                        case PENALTY_PAYMENT_INTERVALS.ONE_HOUR:
                            penalty = appliedRule['penalty_payment_rate'] * usedRate;
                            break;

                        case PENALTY_PAYMENT_INTERVALS.TWO_HOURS:
                            penalty = appliedRule['penalty_payment_rate'] * 2 * usedRate;
                            break;

                        case PENALTY_PAYMENT_INTERVALS.FOUR_HOURS:
                            penalty = appliedRule['penalty_payment_rate'] * 4 * usedRate;
                            break;

                        case PENALTY_PAYMENT_INTERVALS.AFFECTED_HOURS:
                            penalty = appliedRule['penalty_payment_rate'] * (penaltyItem['change_value'] / 3600) * usedRate;
                            break;

                        case PENALTY_PAYMENT_INTERVALS.FOUR_HRS_OR_AFFECTED_HRS_WHICHEVER_LESS:
                            if ((penaltyItem['change_value'] / 3600) < 4) {
                                penalty = appliedRule['penalty_payment_rate'] * (penaltyItem['change_value'] / 3600) * usedRate;
                            } else {
                                penalty = appliedRule['penalty_payment_rate'] * 4 * usedRate;
                            }

                            break;
                    }
                }
            }

            return penalty;
        };

        // shift threshold will be based on defined rules
        // we calculate 2 thresholds for the shift, one based on shift start time with current time/day and the other with week start date
        // we checked the rules for the smallest threshold first , if the smallest one doesn't match , we check the next threshold
        // If the next threshold doesn't match , we check the next rule
        var getAppliedRule = function (shift, changeType, changeValue, penaltiesRules) {
            var appliedShiftRule;
            var shiftThreshold;
            var shiftPenaltyReferenceTimeType;
            var shiftThresholdsKeys = ['OPTIMAL_THRESHOLD', 'POSSIBLE_THRESHOLD'];
            var shiftThresholdsMap = {
                OPTIMAL_THRESHOLD: {},
                POSSIBLE_THRESHOLD: {},
            };
            shiftThresholdsMap['OPTIMAL_THRESHOLD']['value'] = shift.first_day_of_week_threshold < shift.shift_day_threshold ? shift.first_day_of_week_threshold : shift.shift_day_threshold;
            shiftThresholdsMap['OPTIMAL_THRESHOLD']['reference'] = shift.first_day_of_week_threshold < shift.shift_day_threshold ? REFERENCE_TYPES.FIRST_DAY_OF_WEEK : REFERENCE_TYPES.SHIFT_DAY;
            shiftThresholdsMap['POSSIBLE_THRESHOLD']['value'] = shift.first_day_of_week_threshold < shift.shift_day_threshold ? shift.shift_day_threshold : shift.first_day_of_week_threshold;
            shiftThresholdsMap['POSSIBLE_THRESHOLD']['reference'] = shift.first_day_of_week_threshold < shift.shift_day_threshold ? REFERENCE_TYPES.SHIFT_DAY : REFERENCE_TYPES.FIRST_DAY_OF_WEEK;

            for (var i in penaltiesRules) {
                var rulesSet = penaltiesRules[i];
                var threshold = rulesSet.threshold;
                var rules = rulesSet.rules || {};
                var possibleAppliedRule = rules[changeType];

                if (possibleAppliedRule) {
                    for (var key in shiftThresholdsKeys) {
                        var thresholdKey = shiftThresholdsKeys[key];
                        shiftThreshold = shiftThresholdsMap[thresholdKey].value;
                        shiftPenaltyReferenceTimeType = shiftThresholdsMap[thresholdKey].reference;

                        if (
                            shiftThreshold >= 0 &&
                            shiftThreshold <= threshold
                        ) {

                            var shiftLengthRuleOperations = Object.keys(possibleAppliedRule);

                            shiftLengthRuleOperations = shiftLengthRuleOperations.sort(function (operation1, operation2) {
                                return operation1 - operation2;
                            });

                            for (var j in shiftLengthRuleOperations) {
                                var operationKey = shiftLengthRuleOperations[j];
                                var rule = possibleAppliedRule[operationKey];
                                var eligibilitySettings = rule['eligibility_settings'] && rule['eligibility_settings'][0];

                                if (
                                    (
                                        (operationKey === 'GT' && (changeValue / 3600) > eligibilitySettings['value']) ||
                                        (operationKey === 'LTE' && (changeValue / 3600) <= eligibilitySettings['value']) ||
                                        operationKey === 'DEFAULT_RULE'
                                    ) &&
                                    shiftPenaltyReferenceTimeType === rule.shift_penalty_reference_time_type
                                ) {
                                    appliedShiftRule = rule;
                                    break;
                                }
                            }

                        }

                        if (appliedShiftRule) {
                            break;
                        }

                    }
                }

                if (appliedShiftRule) {
                    break;
                }
            }

            return appliedShiftRule;
        };

        var isCoveredPayType = function (userPayType, userCosts, paytypePenaltyRule, date, position) {
            if (!userPayType) {
                return false;
            }

            if (userPayType.type === 'SALARIED' || userPayType.type === 'WEIGHTED_SHIFT') {
                var annualRate = userCosts['annual_rate'] && userCosts['annual_rate'][date] && userCosts['annual_rate'][date]['value'];

                if (!paytypePenaltyRule || !annualRate || (annualRate > paytypePenaltyRule['rate_threshold'])) {
                    return false;
                }
            }

            if (paytypePenaltyRule && userPayType.type === 'HOURLY') {
                var positionCost = position && userCosts[position['code']];
                var shiftPosition = positionCost && positionCost[date];
                var hourCostInCents = parseFloat(shiftPosition && shiftPosition.rate) * 100;

                if (isNaN(hourCostInCents) || (hourCostInCents > paytypePenaltyRule['rate_threshold'])) {
                    return false;
                }
            }

            return true;
        };

        var calculateChanges = function (penaltyRulesMap, tippedRule, coveredEmployeesRules, is24WindowRuleEnabled, scheduleThresholds, usersCostsMap, isEmployeeConsentFlowEnabled, publishedShifts, unpublishedShifts) {
            var penalties = [];
            var flatPublished = angular.copy(publishedShifts);
            var flatUnpublished = angular.copy(unpublishedShifts);
            var maxThreshold = scheduleThresholds[scheduleThresholds.length - 1];

            for (var i in flatUnpublished) {
                var unpublishedShift = flatUnpublished[i];
                var unPublishedShiftThreshold = Math.min(unpublishedShift.first_day_of_week_threshold, unpublishedShift.shift_day_threshold);
                var firstPublishTime = usersPublishedShiftsMap[unpublishedShift.user_id] && usersPublishedShiftsMap[unpublishedShift.user_id]['first_publish'];

                if (unPublishedShiftThreshold > maxThreshold || !unpublishedShift.user_id) {
                    continue;
                }

                var userCosts = usersCostsMap[unpublishedShift.user_id] || {};
                var userPayType = userCosts["pay_type"] && userCosts["pay_type"][unpublishedShift.day];
                var paytypePenaltyRule = userPayType && coveredEmployeesRules[userPayType.type];

                if (!isCoveredPayType(userPayType, userCosts, paytypePenaltyRule, unpublishedShift.day, unpublishedShift.position)) {
                    continue;
                }

                // Exact match check
                var sameShiftIndex = flatPublished.findIndex(function (shift) {
                    return (
                        shift.user_id === unpublishedShift.user_id &&
                        shift.shift_date === unpublishedShift.shift_date &&
                        shift.start_time === unpublishedShift.start_time &&
                        shift.end_time === unpublishedShift.end_time &&
                        shift.status !== 'DELETED' && unpublishedShift.status !== 'DELETED'
                    );
                });

                if (sameShiftIndex > -1) {
                    flatPublished.splice(sameShiftIndex, 1);
                    continue;
                }

                // if 24 window rule enabled, check if first publish was before 14 days
                // and if shift threshold more than or equal 13, ignore the penalty
                if (is24WindowRuleEnabled && firstPublishTime > 14 && unPublishedShiftThreshold >= 13) {
                    var index = flatPublished.findIndex(function (shift) {return shift.reference_id === unpublishedShift.id});

                    if (index > -1) {
                        flatPublished.splice(index, 1);
                    }
                    continue;
                }

                // Check for moved shifts
                var movedShiftIndex = flatPublished.findIndex(function (shift) {
                    return (
                        shift.user_id === unpublishedShift.user_id &&
                        shift.shift_date === unpublishedShift.shift_date &&
                        shift.length === unpublishedShift.length &&
                        shift.status !== 'DELETED' && unpublishedShift.status !== 'DELETED'
                    );
                });

                if (movedShiftIndex > -1) {
                    var publishedShift = angular.copy(flatPublished[movedShiftIndex]);
                    var moveChangeValue = getPenaltyTimeChangeAffectedValue(publishedShift, unpublishedShift);
                    var appliedRule = getAppliedRule(publishedShift, self.SHIFT_PENALTY_CHANGE_TYPES.DATE_TIME_CHANGE, moveChangeValue, penaltyRulesMap);

                    if (appliedRule) {
                        var movePenalty = applyPenalty('MOVE', appliedRule, tippedRule, paytypePenaltyRule, userCosts, isEmployeeConsentFlowEnabled, publishedShift, unpublishedShift ,moveChangeValue);

                        if (movePenalty) {
                            penalties.push(movePenalty);
                        }
                    }

                    flatPublished.splice(movedShiftIndex, 1);
                    continue;
                }

                var absoluteChange = 0;
                var changedShiftIndex = -1;

                for (var j in flatPublished) {
                    var publishShift = flatPublished[j];

                    if (
                        publishShift.user_id === unpublishedShift.user_id &&
                        publishShift.shift_date === unpublishedShift.shift_date &&
                        publishShift.status !== 'DELETED' &&
                        unpublishedShift.status !== 'DELETED'
                    ) {
                        var shiftChange = Math.abs(unpublishedShift.length - publishShift.length);

                        if (absoluteChange < shiftChange) {
                            changedShiftIndex = parseInt(j);
                            absoluteChange = shiftChange;
                        }
                    }
                }

                if (changedShiftIndex > -1) {
                    var publishedShift = angular.copy(flatPublished[changedShiftIndex]);
                    var changeValue = unpublishedShift.length - publishedShift.length;
                    var appliedRule;

                    if (changeValue > 0) {
                        appliedRule = getAppliedRule(publishedShift, self.SHIFT_PENALTY_CHANGE_TYPES.LENGTH_INCREMENT, Math.abs(changeValue), penaltyRulesMap);
                    } else {
                        appliedRule = getAppliedRule(publishedShift, self.SHIFT_PENALTY_CHANGE_TYPES.LENGTH_DECREMENT, Math.abs(changeValue), penaltyRulesMap);
                    }

                    if (appliedRule) {
                        var changeShiftPenalty = applyPenalty('CHANGE', appliedRule, tippedRule, paytypePenaltyRule, userCosts, isEmployeeConsentFlowEnabled, publishedShift, unpublishedShift);

                        if (changeShiftPenalty) {
                            penalties.push(changeShiftPenalty);
                        }
                    }

                    flatPublished.splice(changedShiftIndex, 1);
                    continue;
                }

                if (unpublishedShift.status !== 'DELETED') {
                    var appliedRule = getAppliedRule(unpublishedShift, self.SHIFT_PENALTY_CHANGE_TYPES.LENGTH_INCREMENT, unpublishedShift.length, penaltyRulesMap);

                    if (appliedRule) {
                        var addShiftPenalty = applyPenalty('ADD', appliedRule, tippedRule, paytypePenaltyRule, userCosts, isEmployeeConsentFlowEnabled, null, unpublishedShift);

                        if (addShiftPenalty) {
                            penalties.push(addShiftPenalty);
                        }
                    }
                }
            }

            for (var k in flatPublished) {
                var publishedShift = flatPublished[k];
                var userCosts = usersCostsMap[publishedShift.user_id] || {};
                var userPayType = userCosts["pay_type"] && userCosts["pay_type"][publishedShift.day];
                var paytypePenaltyRule = userPayType && coveredEmployeesRules[userPayType.type];
                var publishedShiftThreshold = Math.min(publishedShift.first_day_of_week_threshold, publishedShift.shift_day_threshold);

                if (
                    publishedShiftThreshold > maxThreshold ||
                    publishedShift.status === 'DELETED' ||
                    !publishedShift.user_id ||
                    !isCoveredPayType(userPayType, userCosts, paytypePenaltyRule, publishedShift.day, publishedShift.position)
                ) {
                    continue;
                }

                var appliedRule = getAppliedRule(publishedShift, self.SHIFT_PENALTY_CHANGE_TYPES.LENGTH_DECREMENT, publishedShift.length, penaltyRulesMap);

                if (appliedRule) {
                    var unPublishedShift = _.findWhere(flatUnpublished, {id: publishedShift.reference_id});
                    publishedShift.is_requested_by_assignee = unPublishedShift && unPublishedShift.is_requested_by_assignee;
                    var subtractShiftPenalty = applyPenalty('SUBTRACT', appliedRule, tippedRule, paytypePenaltyRule, userCosts, isEmployeeConsentFlowEnabled, publishedShift);

                    if (subtractShiftPenalty) {
                        penalties.push(subtractShiftPenalty);
                    }
                }
            }

            return penalties;
        };

        var checkPenaltyReferenceTimeStartOfWeek = function (penaltySettings) {
            if (penaltySettings.length) {
                var latestDate = penaltySettings[0].start_date;
                var activeRule = _.findWhere(penaltySettings, {start_date: latestDate, status: 'ACTIVE'});

                return (activeRule && activeRule['shift_penalty_reference_time_type'] === 'FIRST_DAY_OF_WEEK');
            }
        };

        var calculatePremiumsPenalties = function (brand, startDayOfWeek, schedulePublishFlatData, scheduleUnPublishFlatData, usersFirstPublishTime) {
            var defer = $q.defer();

            scheduleCostsServiceV2
                .getBrandScheduleSettings()
                .then(function (brandScheduleSettings) {
                    var scheduleSettings = angular.copy(brandScheduleSettings);
                    var fairWorkWeekSettings = scheduleSettings['fair_work_week_settings'] || {};
                    var penaltyRulesSettings = fairWorkWeekSettings['penalty_settings'] || [];
                    var isEmployeeConsentFlowEnabled = fairWorkWeekSettings['penalty_general_settings'] && fairWorkWeekSettings['penalty_general_settings'].employee_consent_flow_enabled;
                    var penaltyRulesMap = preparePenaltySettings(penaltyRulesSettings);
                    var tippedRule = getActiveTippedEmployeesRule(scheduleSettings['fair_work_week_settings'] && scheduleSettings['fair_work_week_settings']['penalty_tipped_settings'] || []);
                    var coveredEmployeesRules = getActiveCoveredEmployeesRules(scheduleSettings['fair_work_week_settings'] && scheduleSettings['fair_work_week_settings']['penalty_paytype_settings'] || []);
                    var scheduleThresholds = getScheduleThresholds(penaltyRulesMap);
                    var is24WindowRuleEnabled = check24WindowRuleEnabled(scheduleSettings['fair_work_week_settings'] && scheduleSettings['fair_work_week_settings']['brand_fww_publish_grace_period_settings'] || [], scheduleThresholds);
                    var nowInBrandTimezone = moment(moment().tz(brand.timezoneName).format("YYYY-MM-DDTHH:mm:ss.SSS"));
                    var today = nowInBrandTimezone.format('YYYY-MM-DDTHH:mm:ss.SSS');
                    var weekEnd = moment(startDayOfWeek).add(6, 'days').format('MMM DD, YYYY');
                    var startDayOfNextWeek = moment(startDayOfWeek).add(7, 'days').format('MMM DD, YYYY');

                    if (
                        !scheduleThresholds.length ||
                        moment(weekEnd).diff(today, 'days') < 0 ||
                        moment(startDayOfWeek).diff(today, 'days') > scheduleThresholds[scheduleThresholds.length - 1]
                    ) {
                        defer.resolve([]);
                    } else {
                        var publishedShiftsList = prepareShiftsInfo(schedulePublishFlatData, today, nowInBrandTimezone, startDayOfWeek, startDayOfNextWeek);
                        var unpublishedShiftsList = prepareShiftsInfo(scheduleUnPublishFlatData, today, nowInBrandTimezone, startDayOfWeek, startDayOfNextWeek);

                        if (is24WindowRuleEnabled) {
                            for (var j in usersFirstPublishTime) {
                                var userData = usersFirstPublishTime[j];

                                if (userData['first_publish_datetime']) {
                                    var diff = moment(startDayOfWeek).diff(moment(userData['first_publish_datetime'], 'YYYY-MM-DDTHH:mm:ss'), 'hours');
                                    usersPublishedShiftsMap[userData.user_id] = usersPublishedShiftsMap[userData.user_id] || {};
                                    usersPublishedShiftsMap[userData.user_id]['first_publish'] = diff / 24;
                                }
                            }
                        }

                        scheduleCostsServiceV2
                            .getUsersCostsMap()
                            .then(function (usersCostsMap) {
                                var usersCosts = angular.copy(usersCostsMap) || {};
                                _usersCostMap = angular.copy(usersCostsMap) || {};
                                _coveredEmployeesRules = angular.copy(coveredEmployeesRules);
                                var schedulePenalties = calculateChanges(penaltyRulesMap, tippedRule, coveredEmployeesRules, is24WindowRuleEnabled, scheduleThresholds, usersCosts, isEmployeeConsentFlowEnabled, publishedShiftsList, unpublishedShiftsList);
                                defer.resolve(schedulePenalties);
                            });

                    }
                });

            return defer.promise;
        };

        self.setUserCostMap = function(costMap) {
            _usersCostMap = angular.copy(costMap) || {};
        }

        var loadPublishedSchedulePenalties = function (brandId, weekStartDate) {
            var defer = $q.defer();

            var cacheKey = 'BE_premiums_' + weekStartDate;
            cache[brandId] = cache[brandId] || {};

            if (cache[brandId][cacheKey]) {
                defer.resolve(angular.copy(cache[brandId][cacheKey]));
            }
            else {
                PerformanceAPI
                    .getPublishedSchedulePenalties(brandId, weekStartDate)
                    .then(function (schedulePenalties) {
                        cache[brandId][cacheKey] = angular.copy(schedulePenalties);
                        defer.resolve(schedulePenalties);
                    })
                    .catch(function (err) {
                        console.error(err);
                        defer.reject(err);
                    });
            }

            return defer.promise;
        };

        var getPublishedSchedulePenalties = function (startDayOfWeek, schedulePublishFlatData) {
            var defer = $q.defer();

            teamScheduleService.getActiveBrand()
                .then(function (brand) {
                    var weekStartDate =  moment(startDayOfWeek, 'MMM DD, YYYY');

                    loadPublishedSchedulePenalties(brand.id, weekStartDate)
                        .then(function (clocksPenalties) {
                            var publishedShiftsPenalties = [];

                            for (var i in clocksPenalties) {
                                var clockPenalty = clocksPenalties[i];
                                var shiftId = parseInt(clockPenalty.id);
                                var shift = _.find(schedulePublishFlatData, function (publishedShift) {
                                    return publishedShift.id == shiftId;
                                });

                                if (!shift) {
                                    console.error("can't find shift in published tree ", shiftId);
                                    continue;
                                }

                                clockPenalty.penalties = clockPenalty.penalties || [];
                                clockPenalty.right_to_rest = clockPenalty.right_to_rest || [];

                                for (var p in clockPenalty.penalties) {
                                    clockPenalty.penalties[p]['penalty_type'] = 'PENALTY';
                                }

                                for (var r in clockPenalty.right_to_rest) {
                                    clockPenalty.right_to_rest[r]['penalty_type'] = 'RIGHT_TO_REST';
                                }

                                var penalties = clockPenalty.penalties.concat(clockPenalty.right_to_rest);

                                for (var j in penalties) {
                                    if (
                                        ![
                                            self.PENALTY_SYSTEM_IGNORE_ELIGIBILITY_TYPE.NEW_HIRE,
                                            self.PENALTY_SYSTEM_IGNORE_ELIGIBILITY_TYPE.VOLUNTARY_STANDBY_LIST,
                                            self.PENALTY_SYSTEM_IGNORE_ELIGIBILITY_TYPE.FWW_24_HOUR_WINDOW,
                                            self.PENALTY_SYSTEM_IGNORE_ELIGIBILITY_TYPE.UNASSIGNED_SHIFT_PICKUP,
                                            self.PENALTY_SYSTEM_IGNORE_ELIGIBILITY_TYPE.INAPPLICABLE_SCHEDULED_RIGHT_TO_REST,
                                        ].includes(penalties[j].system_ignore_eligibility_type)
                                    ) {
                                        penalties[j]['shift_id'] = shiftId;
                                        penalties[j]['user_id'] = shift.user_id;
                                        penalties[j]['toShift'] = angular.copy(shift);

                                        var targetShift = penalties[j].penalty_target_shift;
                                        var sourceShift = penalties[j].penalty_source_shift;

                                        if (targetShift) {
                                            var startTime = targetShift.clock_in.substring(0, targetShift.clock_in.length - 1);
                                            var endTime = targetShift.clock_out.substring(0, targetShift.clock_out.length - 1);

                                            penalties[j]['toShift']['start_time'] = moment(startTime).format("MMM DD, YYYY HH:mm");
                                            penalties[j]['toShift']['end_time'] = moment(endTime).format("MMM DD, YYYY HH:mm");
                                            penalties[j]['toShift']['status'] = targetShift.status;
                                        }

                                        if (sourceShift) {
                                            var startTime = sourceShift.clock_in.substring(0, sourceShift.clock_in.length - 1);
                                            var endTime = sourceShift.clock_out.substring(0, sourceShift.clock_out.length - 1);

                                            penalties[j]['fromShift'] = {
                                                start_time: moment(startTime).format("MMM DD, YYYY HH:mm"),
                                                end_time: moment(endTime).format("MMM DD, YYYY HH:mm"),
                                                id: sourceShift.id
                                            };
                                        }

                                        publishedShiftsPenalties.push(penalties[j]);
                                    }
                                }
                            }

                            defer.resolve(publishedShiftsPenalties);
                        })
                        .catch(function (err) {
                            defer.reject(err);
                        });
                });

            return defer.promise;
        };

        var calculatePublishedPenalties = function (penaltyRulesList, usersCostsMap, penaltiesList) {
            var publishedPenalties = [];

            for (var i in penaltiesList) {
                var penaltyItem = penaltiesList[i];
                penaltyItem.notice_period = Math.abs(penaltyItem.notice_period);

                if (penaltyItem.notice_period >= 0 || penaltyItem.duration >= 0) {
                    var shiftDate = moment(penaltyItem.toShift.start_time, 'MMM DD, YYYY HH:mm').format('MMM DD, YYYY');
                    var userId = penaltyItem.toShift.user_id;
                    var userCosts = usersCostsMap[userId] || {};

                    var allowAccess = (
                        penaltyItem.toShift &&
                        penaltyItem.toShift.position &&
                        userCosts[penaltyItem.toShift.position.code] &&
                        userCosts[penaltyItem.toShift.position.code]['allow_access']
                    );

                    var appliedRule = _.find(penaltyRulesList, function (rule) {
                        return (
                            (rule.id === penaltyItem['rule_id']) &&
                            (
                                (rule.shift_penalty_change_type && penaltyItem['penalty_type'] === 'PENALTY') ||
                                (!rule.shift_penalty_change_type && penaltyItem['penalty_type'] === 'RIGHT_TO_REST')
                            )
                        );
                    });

                    if (appliedRule) {
                        var penaltyDetails = self.getPenaltyDetails(penaltyItem, appliedRule, allowAccess);

                        penaltyDetails['day'] = penaltyItem.toShift['day'];
                        penaltyDetails['position'] = penaltyItem.toShift.position;
                        penaltyDetails['toShift'] = penaltyItem.toShift;
                        penaltyDetails['fromShift'] = penaltyItem.fromShift;
                        penaltyDetails['date'] = shiftDate;
                        penaltyDetails['source_brand'] = penaltyItem.source_brand;
                        penaltyDetails['user_id'] = userId;
                        penaltyDetails['status'] = 'published';
                        console.log(penaltyDetails)
                        publishedPenalties.push(penaltyDetails);
                    }
                    else {
                        console.error("Can't find rule:", penaltyItem.rule_id);
                    }
                }
            }

            return publishedPenalties;
        };

        self.getPenaltiesRules = function () {
            var defer = $q.defer();

            teamScheduleService.getActiveBrand()
                .then(function (brand) {

                    if (cache[brand.id] && cache[brand.id]['penalties_rules']) {
                        defer.resolve(angular.copy(cache[brand.id]['penalties_rules']));
                    }
                    else {
                        FairSchedulingAPI.getBrandPenaltiesLookup(brand.id)
                            .then(function (res) {
                                res['penalties'] = res['penalties'] || [];
                                res['right_to_rest_penalties'] = res['right_to_rest_penalties'] || [];
                                var penaltiesRules = res['penalties'].concat(res['right_to_rest_penalties']);

                                cache[brand.id] = cache[brand.id] || {};
                                cache[brand.id]['penalties_rules'] = angular.copy(penaltiesRules);
                                defer.resolve(penaltiesRules);
                            })
                            .catch(function (err) {
                                console.error(err);
                                defer.reject(err);
                            });
                    }
                });

            return defer.promise;
        };

        var calculatePublishedPremiums = function (startDayOfWeek, schedulePublishFlatData) {
            var defer = $q.defer();

            var promises = {
                'penalties_rules': self.getPenaltiesRules(),
                'schedule_settings': scheduleCostsServiceV2.getBrandScheduleSettings(),
                'users_costs_map': scheduleCostsServiceV2.getUsersCostsMap()
            };

            $q.all(promises)
                .then(function (res) {
                    var penaltiesRules = res['penalties_rules'] || [];
                    var usersCostsMap = angular.copy(res['users_costs_map']) || {};

                    if (!penaltiesRules.length) {
                        defer.resolve([]);
                    } else {
                        getPublishedSchedulePenalties(startDayOfWeek, schedulePublishFlatData)
                            .then(function (penaltiesList) {
                                var publishedPenalties = calculatePublishedPenalties(penaltiesRules, usersCostsMap, penaltiesList);

                                defer.resolve(publishedPenalties);
                            })
                            .catch(function (err) {
                                console.error(err);
                                defer.reject(err);
                            });
                    }
                })
                .catch(function (err) {
                    console.error(err);
                    defer.reject(err);
                });

            return defer.promise;
        };

        var applyRightToRestPenalty = function (rightToRestRule, paytypePenaltyRule, userCosts, isEmployeeConsentFlowEnabled, change_value, shift, comparedShift, activeBrandId) {
            var rtrSourceBrand = teamScheduleService.getBrandById(shift.brand_id, true) || {};
            var rtrBrand = teamScheduleService.getBrandById(comparedShift.brand_id, true) || {};
            var rightToRestPenalty = {
                toShift: comparedShift,
                fromShift: shift,
                source_brand: {id: shift.brand_id, name: rtrSourceBrand.name},
                user_id: comparedShift.user_id,
                type: self.SHIFT_PENALTY_CHANGE_TYPES.RIGHT_TO_REST,
                currency: currency,
                day: comparedShift.day,
                rest_period: rightToRestRule.rest_period
            };

            rightToRestPenalty['toShift'].brand = rtrBrand;
            rightToRestPenalty['position'] = comparedShift.position;
            rightToRestPenalty['date'] = moment(comparedShift.start_time, 'MMM DD, YYYY HH:mm').format('MMM DD, YYYY');

            if (rtrBrand && rtrBrand.id !== activeBrandId) {
                rightToRestPenalty['allowed_access'] = false;
                rightToRestPenalty['hide_affected_hrs'] = true;
                return rightToRestPenalty;
            }

            if (isEmployeeConsentFlowEnabled) {
                rightToRestPenalty['isRequiredEmployeeConsent'] = isEmployeeConsentFlowEnabled;
            }

            var restTimeInSeconds = rightToRestRule.rest_period;
            var userPayType = paytypePenaltyRule ? paytypePenaltyRule.payment_type : 'HOURLY';

            if (rightToRestRule['payment_interval'] === 'ALL_SHIFT') {
                // if shift has OT exclude affected hrs from RTR calculation
                //if shift extended and overnight shifts enabled get shift time from the extension also
                var shiftNetTime;

                if (comparedShift['costInfo']) {
                    var hasExtendedShift = !!(scheduleDataServiceV2.flatData['extended_shifts'] && scheduleDataServiceV2.flatData['extended_shifts'][comparedShift.id]);
                    var extensionTime = 0;

                    shiftNetTime = userPayType === 'HOURLY' ? comparedShift['costInfo']['net_time'] : comparedShift['costInfo']['time'];

                    if (hasExtendedShift) {
                        var extensionShift = scheduleDataServiceV2.flatData['extended_shifts'][comparedShift.id];
                        extensionTime = extensionShift['costInfo'] && (userPayType === 'HOURLY' ? extensionShift['costInfo']['net_time'] : extensionShift['costInfo']['time']);
                    }

                    shiftNetTime += extensionTime;
                }

                rightToRestPenalty['change_value'] = shiftNetTime;
            } else if (rightToRestRule['payment_interval'] === 'AFFECTED_HOURS') {
                // affected hrs worked hrs during rest period
                if (change_value < 0) {
                    var start = new Date(shift.end_time).getTime();
                    var end = new Date(comparedShift.end_time).getTime();

                    rightToRestPenalty['change_value'] = (end - start) / 1000;
                } else {
                    var start = new Date(comparedShift.start_time).getTime();
                    var endShift = new Date(comparedShift.end_time).getTime();
                    var endRestPeriod = moment(shift.end_time).clone().add(restTimeInSeconds, 'seconds').valueOf();
                    var end = endShift < endRestPeriod ? endShift : endRestPeriod;

                    rightToRestPenalty['change_value'] = (end - start) / 1000;
                }
            }

            var allowAccess = (
                comparedShift.position &&
                userCosts[comparedShift.position.code] &&
                userCosts[comparedShift.position.code]['allow_access']
            );

            rightToRestPenalty['allow_access'] = allowAccess;

            //when settings fixed, affected hrs --
            //when entire shift, affected hrs all shift without subtract OT
            if (rightToRestRule['payment_type'] === 'FIXED') {
                rightToRestPenalty['penalty'] = rightToRestRule.payment_value / 100;
                rightToRestPenalty['hide_affected_hrs'] = true;
            } else {

                let usedRate = getEmployeeHourlyRate(userPayType, userCosts, rightToRestPenalty, null, rightToRestRule[TeamScheduleAPI.RESPONSE_TAGS.PAYMENT_TYPE]);

                rightToRestPenalty['penalty'] = rightToRestRule['payment_rate'] * (angular.copy(rightToRestPenalty['change_value']) / 3600) * usedRate;

                if (rightToRestRule['payment_interval'] === 'ALL_SHIFT') {
                    rightToRestPenalty['change_value'] = comparedShift.length;
                }
            }

            return rightToRestPenalty;
        };

        var getUserShifts = function (shiftsList, userId) {
            return shiftsList.filter(function (shift) {
                return (shift['user_id'] === userId && shift['status'] !== 'DELETED');
            });
        };

        let calculateRightToRestList = (rightToRestRule, coveredEmployeesRules, usersCosts, isEmployeeConsentFlowEnabled, scheduleUnPublishFlatData, dayBeforeUserShifts, activeBrandId) => {
            var rightToRestList = [];
            var restTimeInSeconds = rightToRestRule.rest_period;
            var changeTime = moment();
            var scheduledUsers = scheduleDataServiceV2.flatData['users'] || {};

            for (var i in scheduledUsers) {
                var userId = scheduledUsers[i]['id'];
                var userCosts = usersCosts[userId] || {};

                if (userId === null) {
                    continue;
                }
                var userShifts = getUserShifts(scheduleUnPublishFlatData, userId);
                let userDayBeforeShifts = getUserShifts(dayBeforeUserShifts, userId);
                var userCrossScheduleShifts = [];
                var userDayBeforeCrossScheduleShifts = [];
                var allUserShifts = userDayBeforeShifts.concat(userShifts);
                var shiftsToCompare = userShifts;

                for (var c in scheduleDataServiceV2.crossFlatData) {
                    var crossBrandShifts = Object.values(scheduleDataServiceV2.crossFlatData[c]['shifts']) || [];
                    var userBrandCrossShifts = getUserShifts(crossBrandShifts, userId);
                    userCrossScheduleShifts = userCrossScheduleShifts.concat(userBrandCrossShifts);
                }
                for (var bc in scheduleDataServiceV2.extraCrossDayFlatData['brands']) {
                    var dayBeforeCrossBrandShifts = scheduleDataServiceV2.extraCrossDayFlatData['brands'][bc]['shifts'] && Object.values(scheduleDataServiceV2.extraCrossDayFlatData['brands'][bc]['shifts']) || [];
                    var userDayBeforeBrandCrossShifts = getUserShifts(dayBeforeCrossBrandShifts, userId);
                    userDayBeforeCrossScheduleShifts = userDayBeforeCrossScheduleShifts.concat(userDayBeforeBrandCrossShifts);
                }
                allUserShifts = allUserShifts.concat(userCrossScheduleShifts).concat(userDayBeforeCrossScheduleShifts);
                shiftsToCompare = shiftsToCompare.concat(userCrossScheduleShifts);

                var sortedShifts = allUserShifts.sort(function (shift1, shift2) {
                    return new Date(shift1.start_time).getTime() > new Date(shift2.start_time).getTime() ? 1 : -1;
                });

                for (var s in sortedShifts) {
                    var unpublishedShift = sortedShifts[s];
                    var unpublishedShiftEndTime = _scheduleDateUtilsService.moment(unpublishedShift.end_time);

                    for (var cs in shiftsToCompare) {
                        var shift = shiftsToCompare[cs];
                        if (unpublishedShift.id === shift.id) {
                             continue;
                        }
                        var isAfterShift = true;
                        var userPayType = userCosts["pay_type"] && userCosts["pay_type"][shift.day];
                        var paytypePenaltyRule = userPayType && coveredEmployeesRules[userPayType.type];


                        if (!isCoveredPayType(userPayType, userCosts, paytypePenaltyRule, shift.day, shift.position)) {
                            continue;
                        }

                        if (_scheduleDateUtilsService.moment(shift.start_time).diff(changeTime) < 0) {
                            continue;
                        }

                        var differenceInSeconds = _scheduleDateUtilsService.moment(shift.start_time).diff(unpublishedShiftEndTime, 'seconds');

                        if (differenceInSeconds < 0) {
                            isAfterShift = _scheduleDateUtilsService.moment(shift.end_time).isAfter(unpublishedShiftEndTime);
                        }

                        if (
                            (shift.status !== 'PUBLISHED' || unpublishedShift.status !== 'PUBLISHED') &&
                            isAfterShift &&
                            differenceInSeconds < restTimeInSeconds &&
                            !_scheduleDateUtilsService.moment(unpublishedShift.start_time).isSame(_scheduleDateUtilsService.moment(shift.start_time), 'days')
                        ) {
                            var rightToRestPenalty = applyRightToRestPenalty(rightToRestRule, paytypePenaltyRule, userCosts, isEmployeeConsentFlowEnabled, differenceInSeconds, unpublishedShift, shift, activeBrandId);
                            rightToRestList.push(rightToRestPenalty);
                            break;
                        }
                    }
                }
            }

            return rightToRestList;
        };

        self.getActiveRightToRestSettings = (rightToRestSettings) => {
            var latestRule;

            if (rightToRestSettings.length) {
                rightToRestSettings.sort(function (item1, item2) {
                    return new Date(item1.start_date).getTime() > new Date(item2.start_date).getTime() ? -1 : 1;
                });

                var latestDate = rightToRestSettings[0] && rightToRestSettings[0].start_date;
                latestRule = _.findWhere(rightToRestSettings, {start_date: latestDate, status: 'ACTIVE'});
            }

            return latestRule;
        };

        var calculateRightToRestPenalties = function (startDayOfWeek, scheduleUnPublishFlatData) {
            var defer = $q.defer();

            teamScheduleService.getActiveBrand()
                .then(function (brand) {
                    var prePromises = {
                        'users_costs_map': scheduleCostsServiceV2.getUsersCostsMap(),
                        'brand_schedule_settings': scheduleCostsServiceV2.getBrandScheduleSettings()
                    };

                    $q.all(prePromises)
                        .then(function (result) {
                            var scheduleSettings = angular.copy(result['brand_schedule_settings']);
                            var usersCosts = angular.copy(result['users_costs_map']);
                            let rightToRestRule = self.getActiveRightToRestSettings(scheduleSettings['right_to_rest_settings'] || []);
                            var fairWorkWeekSettings = scheduleSettings['fair_work_week_settings'] || {};
                            var isEmployeeConsentFlowEnabled = fairWorkWeekSettings['penalty_general_settings'] && fairWorkWeekSettings['penalty_general_settings'].employee_consent_flow_enabled;
                            var coveredEmployeesRules = getActiveCoveredEmployeesRules(scheduleSettings['fair_work_week_settings'] && scheduleSettings['fair_work_week_settings']['penalty_paytype_settings'] || []);

                            if (rightToRestRule && rightToRestRule.status === 'ACTIVE') {
                                let dayBeforeUserShifts = Object.values(scheduleDataServiceV2.extraDayFlatData?.shifts ?? {});
                                let rightToRestList = calculateRightToRestList(
                                    rightToRestRule,
                                    coveredEmployeesRules,
                                    usersCosts,
                                    isEmployeeConsentFlowEnabled,
                                    scheduleUnPublishFlatData,
                                    dayBeforeUserShifts,
                                    brand.id
                                );

                                defer.resolve(rightToRestList);

                            } else {
                                defer.resolve([]);
                            }
                        });
                });

            return defer.promise;
        };

        var applyFiltersOnPenalty = function (appliedFilters, penaltiesList) {
            var categoriesFilters = [];
            var positionsFilters = [];
            var usersFilters = [];
            var premiumsTypeFilters = [];
            var filteredPenaltiesList = [];
            var requestedByAssigneeFilters = [];
            var consentStatusesFilters = [] ;

            if (appliedFilters['category_codes']) {
                categoriesFilters = _.pluck(appliedFilters['category_codes'], 'code') || [];
            } else if (appliedFilters['categories']) {
                categoriesFilters = _.pluck(appliedFilters['categories'], 'code') || [];
            }

            if (appliedFilters['position_codes']) {
                positionsFilters = _.pluck(appliedFilters['position_codes'], 'code') || [];
            } else if (appliedFilters['positions']) {
                positionsFilters = _.pluck(appliedFilters['positions'], 'code') || [];
            }

            if (appliedFilters['user_ids']) {
                usersFilters = _.pluck(appliedFilters['user_ids'], 'id') || [];
            } else if (appliedFilters['user']) {
                usersFilters = [appliedFilters['user'].id] || [];
            }

            if (appliedFilters['premium_types']) {
                premiumsTypeFilters = _.pluck(appliedFilters['premium_types'], 'code') || [];
            }

            if (appliedFilters['requested_by_assignee']) {
                requestedByAssigneeFilters = _.pluck(appliedFilters['requested_by_assignee'],'key') || [];
            }

            if(appliedFilters['consent_statuses']){
                consentStatusesFilters = _.pluck(appliedFilters['consent_statuses'],'key') || [] ;
            }

            for (var i in penaltiesList) {
                var penaltyItem = penaltiesList[i];

                if (appliedFilters['onlyUnpublished'] && penaltyItem.status === 'published') {
                    continue;
                }

                if (premiumsTypeFilters.length && premiumsTypeFilters.indexOf(penaltyItem.type) === -1) {
                    continue;
                }

                if (requestedByAssigneeFilters.length && penaltyItem.isRequestedByAssignee && penaltyItem.isRequestedByAssignee.key && requestedByAssigneeFilters.indexOf(penaltyItem.isRequestedByAssignee.key) === -1) {
                    continue;
                }

                if (consentStatusesFilters.length && (!penaltyItem.employeeConsent || (penaltyItem.employeeConsent.status && consentStatusesFilters.indexOf(penaltyItem.employeeConsent.status) === -1))) {
                    continue;
                }

                if (categoriesFilters.length > 0 && categoriesFilters.indexOf(penaltyItem.position.category.code) === -1) {
                    continue;
                }

                if (positionsFilters.length > 0 && positionsFilters.indexOf(penaltyItem.position.code) === -1) {
                    continue;
                }

                if (usersFilters.length > 0 && usersFilters.indexOf(penaltyItem.user_id) === -1) {
                    continue;
                }

                filteredPenaltiesList.push(penaltyItem);
            }

            return filteredPenaltiesList;
        };

        self.getUsersWithRTRRulesViolations = function (schedulePremiums, filteredOptions) {
            var usersShifts = [];
            var usersWithRTRViolations = [];
            if (filteredOptions) {
                if (filteredOptions['shiftId'] && scheduleDataServiceV2.flatData['shifts'][filteredOptions['shiftId']]) {
                    usersShifts.push(scheduleDataServiceV2.flatData['shifts'][filteredOptions['shiftId']]);
                } else if (filteredOptions['userId'] || filteredOptions['filteredUserIds'] && filteredOptions['filteredUserIds'].length) {
                    var userIds = filteredOptions['userId'] ? [filteredOptions['userId']] : filteredOptions['filteredUserIds'];

                    for (var i in userIds) {
                        var userId = userIds[i];
                        var userData = scheduleDataServiceV2.flatData['users'][userId];
                        var userShiftIds = userData && userData['shift_ids'] || [];

                        for (var s in userShiftIds) {
                            var shiftId = userShiftIds[s];
                            usersShifts.push(scheduleDataServiceV2.flatData['shifts'][shiftId]);
                        }
                    }
                }
            } else {
                for (var shiftId in scheduleDataServiceV2.flatData['shifts']) {
                    usersShifts.push(scheduleDataServiceV2.flatData['shifts'][shiftId]);
                }
            }

            for (var i in usersShifts) {
                var shift = usersShifts[i];

                if (shift.user_id && shift.status !== 'DELETED') {
                    var penaltyDetails = schedulePremiums.find(function (penalty) {
                        return (penalty.user_id === shift.user_id) && penalty.type == "RIGHT_TO_REST";
                    });
                    if (penaltyDetails && usersWithRTRViolations.indexOf(penaltyDetails.user_id) === -1) {
                        usersWithRTRViolations.push(penaltyDetails.user_id)
                    }
                }
            }
            return usersWithRTRViolations;

        };

        self.calculateSchedulePremiums = function (startDayOfWeek, appliedFilters, onlyUnpublished, onlyRightToRest) {
            var defer = $q.defer();

            teamScheduleService.getActiveBrand()
                .then(function (brand) {
                    currency = _filter("locationCurrencySymbol")(brand);

                    UserServices.isServiceEnabled(UserServices.SERVICES.FAIR_SCHEDULING, brand.id)
                        .then(function (isFairSchedulingServiceEnabled) {
                            if (isFairSchedulingServiceEnabled) {
                                var crossScheduleBrandIds = scheduleDataServiceV2.getCrossScheduleBrandIds();

                                var promises = {
                                    'schedulePublishTree': self.loadSchedulePublishTree(brand.id, startDayOfWeek),
                                    'scheduleUnPublishDataMap': scheduleDataServiceV2.getScheduleUnPublishedFlatData(),
                                    'usersFirstPublishTime': getUsersFirstPublishTime(brand.id, startDayOfWeek)
                                };

                                if (crossScheduleBrandIds.length) {
                                    promises['brands_details'] = teamScheduleService.prepareBrandWithNoAccessMap(brand.financial_unit_brand_id, crossScheduleBrandIds)
                                }

                                $q.all(promises)
                                    .then(function (res) {
                                        var schedulePublishFlatData = self.parseFlatScheduleData(res['schedulePublishTree'] || {});
                                        var scheduleUnPublishDataMap = angular.copy(res['scheduleUnPublishDataMap']) || {};
                                        var usersFirstPublishTime = res['usersFirstPublishTime'];
                                        var scheduleUnPublishFlatData = [];

                                        for (var i in scheduleUnPublishDataMap) {
                                            scheduleUnPublishFlatData.push(scheduleUnPublishDataMap[i]);
                                        }

                                        scheduleUnPublishFlatData.sort(function (shift1, shift2) {
                                            if (shift1.status === 'PUBLISHED' && shift2.status !== 'PUBLISHED') {
                                                return -1;
                                            }

                                            if (shift2.status === 'PUBLISHED' && shift1.status !== 'PUBLISHED') {
                                                return 1;
                                            }

                                            return new Date(shift1.start_time).getTime() > new Date(shift2.start_time).getTime() ? 1 : -1;
                                        });

                                        for (var j in schedulePublishFlatData) {
                                            var publishedShift = schedulePublishFlatData[j];

                                            if (publishedShift.user_id) {
                                                usersPublishedShiftsMap[publishedShift.user_id] = {hasPublishedShifts: true};
                                            }
                                        }

                                        var calculationsPromises = {
                                            'rightToRestList': calculateRightToRestPenalties(startDayOfWeek, scheduleUnPublishFlatData)
                                        };

                                        if (!onlyRightToRest) {
                                            calculationsPromises['premiumsList'] = calculatePremiumsPenalties(brand, startDayOfWeek, schedulePublishFlatData, scheduleUnPublishFlatData, usersFirstPublishTime);
                                        }

                                        if (!onlyUnpublished) {
                                            calculationsPromises['publishedPremiumsList'] = calculatePublishedPremiums(startDayOfWeek, schedulePublishFlatData);
                                        }

                                        $q.all(calculationsPromises)
                                            .then(function (result) {
                                                result['premiumsList'] = result['premiumsList'] || [];
                                                var penaltiesList = result['premiumsList'].concat(result['rightToRestList']);
                                                result['publishedPremiumsList'] = result['publishedPremiumsList'] || [];

                                                penaltiesList.sort(function (penalty1, penalty2) {
                                                    return moment(penalty1.date).isBefore(penalty2.date) ? 1 : -1;
                                                });

                                                result['publishedPremiumsList'].sort(function (penalty1, penalty2) {
                                                    return moment(penalty1.date).isBefore(penalty2.date) ? 1 : -1;
                                                });

                                                penaltiesList = penaltiesList.concat(result['publishedPremiumsList']);

                                                if ((appliedFilters && Object.keys(appliedFilters).length) || onlyUnpublished) {
                                                    var filters = angular.copy(appliedFilters) || {};
                                                    filters['onlyUnpublished'] = onlyUnpublished;

                                                    penaltiesList = applyFiltersOnPenalty(filters, penaltiesList);
                                                }

                                                defer.resolve(penaltiesList);
                                            })
                                            .catch(function (err) {
                                                console.error(err);
                                                defer.reject(err);
                                            });
                                    })
                                    .catch(function (err) {
                                        console.error(err);
                                        defer.reject(err);
                                    });
                            } else {
                                defer.resolve([]);
                            }
                        })
                        .catch(function (err) {
                            console.error("Failed to check service for brand:", brand.id);
                            defer.resolve([]);
                        });
                });

            return defer.promise;
        };

        self.updateUsersPublishShiftsMap = function (userIds) {
            if (userIds && userIds.length) {
                for (var i in userIds) {
                    var userId = parseInt(userIds[i]);
                    var updatePublishTime = false;

                    if (!usersPublishedShiftsMap[userId] || !usersPublishedShiftsMap[userId]['first_publish']) {
                        updatePublishTime = true;
                    }

                    usersPublishedShiftsMap[userId] = usersPublishedShiftsMap[userId] || {};
                    usersPublishedShiftsMap[userId]['hasPublishedShifts'] = true;

                    if (updatePublishTime) {
                        usersPublishedShiftsMap[userId]['first_publish'] = moment(scheduleDataServiceV2.startDate).diff(moment(), 'hours') / 24;
                    }
                }
            } else {
                usersPublishedShiftsMap = {};
            }
        };

        self.isNewlyHiedWithNoPublishSchedule = function (date, userId, forWeek, position) {
            var hasPublishedShifts = usersPublishedShiftsMap[userId] && usersPublishedShiftsMap[userId].hasPublishedShifts;
            var userCosts = _usersCostMap[userId] || {};
            var payTypesDaysKeys = userCosts["pay_type"] && Object.keys(userCosts["pay_type"]) || [];
            var selectedDate = forWeek ? payTypesDaysKeys[0] : date;
            var userPayType = userCosts["pay_type"] && userCosts["pay_type"][selectedDate];
            var paytypePenaltyRule = userPayType && _coveredEmployeesRules[userPayType.type];

            if (userId && !isNaN(userId)) {
                if (position) {
                    if (!isCoveredPayType(userPayType, userCosts, paytypePenaltyRule, selectedDate, position)) {
                        return false;
                    }
                } else {
                    var userRoleIds = scheduleDataServiceV2.flatData['users'][userId] && scheduleDataServiceV2.flatData['users'][userId]['role_ids'] || [];
                    var isCoveredEmployee = false;

                    for (var i in userRoleIds) {
                        var roleId = userRoleIds[i];
                        var role = scheduleDataServiceV2.flatData['roles'][roleId]['position'];

                        isCoveredEmployee = isCoveredEmployee || isCoveredPayType(userPayType, userCosts, paytypePenaltyRule, selectedDate, role);
                    }

                    if (!isCoveredEmployee) {
                        return false;
                    }
                }
            }

            // will consider start of week to calculate newly hires and this may change to be based on settings
            var considerStartOfWeek = true;
            var newHireDate = scheduleDataServiceV2.startDate;
            var isNewlyHied = scheduleDataServiceV2.isNewlyHied(newHireDate, userId, considerStartOfWeek);

            return isNewlyHied && !hasPublishedShifts;
        };

        self.prepareNewlyHiredMap = function (date, forWeek, users, sortBy) {
            var newlyHiredMap = {};

            if (!users) {
                users = scheduleDataServiceV2.getScheduleUsersByDay(forWeek ? undefined : date);
            }

            for (var i in users) {
                var userId = parseInt(users[i]);
                var userRoleIds = scheduleDataServiceV2.flatData['users'][userId] && scheduleDataServiceV2.flatData['users'][userId]['role_ids'] || [];

                for (var j in userRoleIds) {
                    var roleId = userRoleIds[j];
                    var role = scheduleDataServiceV2.flatData['roles'][roleId]['position'];
                    var isNewlyHiredEmployee = self.isNewlyHiedWithNoPublishSchedule(date, userId, forWeek, role);

                    if (isNewlyHiredEmployee) {
                        if (sortBy === 'ROLE_PERSON') {
                            newlyHiredMap[userId] = newlyHiredMap[userId] || {roles: {}};
                            newlyHiredMap[userId]['roles'][roleId] = {isNewlyHied: true, userId: userId, roleId: roleId};
                        } else {
                            newlyHiredMap[userId] = {isNewlyHied: true, userId: userId};
                        }

                    }
                }
            }

            return newlyHiredMap;
        };

        self.getPenaltyDetails = function (penaltyItem, rule, allowAccess) {
            var penaltyDetails = {
                type: rule.shift_penalty_change_type || self.SHIFT_PENALTY_CHANGE_TYPES.RIGHT_TO_REST,
                penalty: (rule.penalty_payment_value || rule.payment_value || 0) / 100,
                allow_access: allowAccess,
                currency: currency
            };

            if (penaltyDetails['type'] !== self.SHIFT_PENALTY_CHANGE_TYPES.RIGHT_TO_REST) {
                if (rule['shift_penalty_change_threshold_type'] === 'HOUR') {
                    penaltyDetails['notice_period'] = 0;
                } else {
                    penaltyDetails['notice_period'] = Math.floor(penaltyItem.notice_period / 24 / 3600);
                }

                penaltyDetails['change_value'] = Utils.roundFloat(penaltyItem.change_value || 0);
                penaltyDetails['notice_type'] = rule.shift_penalty_change_threshold_type;

            } else {
                if (rule['payment_type'] === 'FIXED') {
                    penaltyDetails['hide_affected_hrs'] = true;
                }

                penaltyDetails['change_value'] = Utils.roundFloat(penaltyItem.duration || 0);
            }

            if (penaltyItem.amount === null) {
                penaltyDetails['show_undefined_penalty'] = true;
            }

            penaltyDetails['penalty'] = penaltyItem.amount / 100;
            penaltyDetails['employeeConsent'] = penaltyItem.consent;
            penaltyDetails['isRequestedByAssignee'] = {
                key: penaltyItem.is_requested_by_assignee ? 'YES' : 'NO',
                value: penaltyItem.is_requested_by_assignee ? _filter('translate')('Yes') : _filter('translate')('No')
            };
            return penaltyDetails;
        };

        var getLongestRuleNoticePeriod = function (penaltyRules) {
            var referenceTimeTypes = [];
            var noticerPeriod;

            for (var i in penaltyRules) {
                var types = Object.keys(penaltyRules[i]) || [];
                var premuimType = types.length ? penaltyRules[i][types[0]] : {};

                if (referenceTimeTypes.length && !referenceTimeTypes.includes(premuimType.shift_penalty_reference_time_type)) {
                    noticerPeriod = REFERENCE_TYPES.FIRST_DAY_OF_WEEK;
                    break;
                }

                referenceTimeTypes.push(premuimType.shift_penalty_reference_time_type);
                noticerPeriod = premuimType.shift_penalty_reference_time_type;
            }

            return noticerPeriod;
        };

        self.checkFairSchedulingWeekThresholdStatus = function (fairScheduleSettings, range, oneDay) {
            var fairSchedulingWeekStatus = {};

            if (fairScheduleSettings.length) {
                var todayDate = moment().format('YYYY-MM-DD');
                var viewedDate = range.from.clone();
                var penaltyRulesMap = preparePenaltySettings(fairScheduleSettings);
                var penaltyThreshold = Object.keys(penaltyRulesMap) || [];
                var penaltyRules = penaltyRulesMap[penaltyThreshold[penaltyThreshold.length - 1]].rules || {};
                var noticePeriod = getLongestRuleNoticePeriod(penaltyRules);
                if (noticePeriod === REFERENCE_TYPES.SHIFT_DAY) {
                    var viewType = scheduleDataServiceV2.getActiveScheduleViewType();

                    if (viewType && viewType.id === 'DAILY') {
                        var activeScheduleDay = scheduleDataServiceV2.getActiveScheduleDay();
                        viewedDate = moment(activeScheduleDay).clone();
                    }
                }
                var referenceDifference = moment(viewedDate, 'YYYY-MM-DD').diff(moment(todayDate, 'YYYY-MM-DD'), 'days');
                var endOfWeekDifference = moment(range.to, 'YYYY-MM-DD').diff(moment(todayDate, 'YYYY-MM-DD'), 'days');
                var maxThreshold = parseInt(penaltyThreshold[penaltyThreshold.length - 1]);

                if (penaltyThreshold.length) {
                    if (oneDay) {
                        if (referenceDifference >= 0 && referenceDifference < maxThreshold) {
                            fairSchedulingWeekStatus['weekThresholdStatus'] = 'WITHIN_NOTICE';
                        }
                    } else {
                        if (endOfWeekDifference < 0) {
                            fairSchedulingWeekStatus['weekThresholdStatus'] = 'PAST';
                        } else if (referenceDifference >= maxThreshold) {
                            fairSchedulingWeekStatus['weekThresholdStatus'] = 'FUTURE';
                            fairSchedulingWeekStatus['maxNoticePublishDate'] = viewedDate.clone().subtract(maxThreshold + 1, 'days');
                        } else {
                            fairSchedulingWeekStatus['weekThresholdStatus'] = 'WITHIN_NOTICE';
                        }
                    }
                }
            }

            return fairSchedulingWeekStatus;
        };

        self.checkUpdatedPremiums = (oldPremiums, updatedPremiums) => {
            let newPenalties = [];

            if (oldPremiums) {
                for (let penaltyDetails of updatedPremiums) {
                    let isDuplicatePenalty = oldPremiums.some((penaltyItem) => {
                        return (
                            penaltyDetails.user_id === penaltyItem.user_id &&
                            penaltyDetails.type === penaltyItem.type &&
                            penaltyDetails.toShift?.id === penaltyItem.toShift?.id &&
                            penaltyDetails.fromShift?.id === penaltyItem.fromShift?.id &&
                            penaltyDetails.change_value === penaltyItem.change_value &&
                            penaltyDetails.penalty === penaltyItem.penalty
                        );
                    });

                    if (!isDuplicatePenalty) {
                        newPenalties.push(penaltyDetails);
                    }
                }
            }

            return newPenalties;
        };

        var getScheduleAuditData = function (startDateOfWeek) {
            var defer = $q.defer();

            teamScheduleService.getActiveBrand()
                .then(function (brand) {
                    self.loadSchedulePublishTree(brand.id, startDateOfWeek)
                        .then(function (publishedTree) {
                            var schedulePublishFlatData = self.parseFlatScheduleData(publishedTree || {});
                            var data = [];

                            for (var i in schedulePublishFlatData) {
                                var shift = schedulePublishFlatData[i];
                                var employeeInfo = shift.user_id && (_TSUsersService.users[shift.user_id] || {});
                                var employeeName = shift.user_id ? [employeeInfo['first_name'], employeeInfo['last_name']].join(" ") : "Unassigned";
                                var publishDate = shift.exposure_time ? moment(shift.exposure_time).format("MMM D, YYYY HH:mm") : "--";

                                data.push({
                                    'employeeName': employeeName,
                                    'positionName': shift.position.name,
                                    'startTime': shift.start_time,
                                    'endTime': shift.end_time,
                                    'publishDate': publishDate,
                                    'shiftHours': Utils.roundFloat(moment(shift.end_time).diff(shift.start_time, 'minutes') / 60),
                                    'deleted': shift.status === 'DELETED' ? 'Yes' : ''
                                });
                            }

                            defer.resolve(data);
                        })
                        .catch(function (err) {
                            console.error(err);
                            defer.reject();
                        });
                })
                .catch(function (err) {
                    console.error(err);
                    defer.reject();
                });

            return defer.promise;
        };

        var getUsersFirstPublishTime = function (brandId, startDateOfWeek) {
            var defer = $q.defer();
            var cacheKey = startDateOfWeek + '_' + 'PUBLISHED_TIME';
            cache[brandId] = cache[brandId] || {};

            if (cache[brandId][cacheKey]) {
                defer.resolve(angular.copy(cache[brandId][cacheKey]));
            } else {
                EmployeeClockStatsAPI
                    .getScheduledUsersFirstPublishTime(brandId, {week_date: moment(startDateOfWeek).format("YYYY-MM-DD")})
                    .then(function (res) {
                        var users = res['users'] || [];
                        cache[brandId][cacheKey] = users;
                        defer.resolve(users);
                    })
                    .catch(function (err) {
                        console.error(err);
                        defer.reject();
                    });
            }

            return defer.promise;
        };

        self.printScheduleAudit = function (startDateOfWeek) {
            var defer = $q.defer();

            getScheduleAuditData(startDateOfWeek)
                .then(function (data) {
                    var title = 'schedule-audit-' + moment(startDateOfWeek).format("YYYY-MMM-DD");

                    var htmlString = _nunjucks.render(
                        "../modules/scheduler_v2/views/print-schedule-audit.njk",
                        {
                            dataRows: data,
                            startWeek: moment(startDateOfWeek),
                            endWeek: moment(startDateOfWeek).add(1, 'w')
                        });

                    var onFinish = function () {
                        defer.resolve();
                    };

                    Utils.print(title, htmlString, onFinish);
                })
                .catch(function (err) {
                    console.error(err);
                    defer.reject();
                });

            return defer.promise;
        };

        var rejectShiftConsent = function (brandId, consentId, defer) {
            var params = {
                consents: [
                    {
                        id: consentId,
                        status: 'REJECTED'
                    }
                ]
            }
            TeamScheduleAPI.updateShiftConsents(brandId, params)
                .then(function (res) {
                    HNotifications.show({
                        title: $filter("translate")('Success'),
                        desc: $filter("translate")("Shift has been restored"),
                        timeout: 3000,
                        icon: "fa-check-circle",
                        type: "success"
                    });
                    self.clearCache();
                    defer.resolve(res);
                })
                .catch(function (err) {
                    HNotifications.show({
                        title: $filter("translate")("Error"),
                        desc: $filter("translate")("Error while restoring shift"),
                        timeout: 3000,
                        icon: "fa-times",
                        type: "danger"
                    });
                    defer.reject(err);
                });

            return defer.promise;
        };

        self.restoreConsent = function (brandId, consentId, userId) {
            var defer = $q.defer();

            TeamScheduleAPI.getShiftConsentDetailsByEmployer(brandId, userId, consentId)
                .then(function (response) {
                    var consent = response;
                    var msg = $filter("translate")('Are you sure you want to set the shift as unassigned') + '?';

                    if (consent.assignee_shift_snapshot) {
                        msg = $filter("translate")('Are you sure you want to restore the shift times to its latest published status') + ' ?';

                        if (consent.start_time && consent.end_time) {
                            msg += '<br/><br/><ul>'
                                + '<li>' + $filter("translate")('From') + ': ' + moment(consent.start_time).format('h:mm a') + ' - ' + moment(consent.end_time).format('h:mm a') + '</li>';
                        } else {
                            msg += '<br/><br/><ul>'
                                + '<li>' + $filter("translate")('From') + ': ' + $filter("translate")('Deleted Shift') + '</li>';
                        }

                        msg += '<li>' + $filter("translate")('To') + ': ' + moment(consent.assignee_shift_snapshot.start_time).format('h:mm a') + ' - ' + moment(consent.assignee_shift_snapshot.end_time).format('h:mm a') + '</li>'
                            + '</ul>';
                    }

                    hConfirm(
                        {
                            title: $filter("translate")('Restore Shift Changes'),
                            text: msg,
                            confirmButton: $filter("translate")("Restore"),
                            dialogClass: 'modal-sm',
                            callback: function (confirmed) {
                                if (confirmed) {
                                    rejectShiftConsent(brandId, consentId, defer);
                                } else {
                                    defer.reject('DISCARD_MODAL');
                                }
                            }
                        });
                })
                .catch(function (err) {
                    console.error(err);
                    defer.reject(err);
                });

            return defer.promise;
        };

        self.SHIFT_PENALTY_CHANGE_TYPES = {
            LENGTH_DECREMENT: 'LENGTH_DECREMENT',
            DATE_TIME_CHANGE: 'DATE_TIME_CHANGE',
            LENGTH_INCREMENT: 'LENGTH_INCREMENT',
            RIGHT_TO_REST: 'RIGHT_TO_REST'
        };

        self.reset = function () {
            usersPublishedShiftsMap = {};
        };

        self.clearCache = function () {
            cache = {};
        };
    }

    app.service('fairSchedulingService', [
        '$filter', 'ScheduleDataServiceV2', 'ScheduleCostsServiceV2', 'TeamScheduleService', 'userServices', 'TSUsersService', 'DispatcherServices', 'scheduleDateUtilsService',
        function ($filter, ScheduleDataServiceV2, ScheduleCostsServiceV2, TeamScheduleService, userServices, TSUsersService, DispatcherServices, scheduleDateUtilsService) {
            scheduleDataServiceV2 = ScheduleDataServiceV2;
            scheduleCostsServiceV2 = ScheduleCostsServiceV2;
            teamScheduleService = TeamScheduleService;
            UserServices = userServices;
            _TSUsersService = TSUsersService;
            _filter = $filter;
            _nunjucks = DispatcherServices.getNunjucks();
            _scheduleDateUtilsService = scheduleDateUtilsService;

            return new FairSchedulingService();
        }
    ]);
})();
